export const SUBSIDIZED_MORTGAGE_ENABLED_KEY = 'frontend-serp.subsidizedMortgage.Enabled';
export const SUBSIDIZED_MORTGAGE_LABEL_TEXT_KEY = 'frontend-serp.subsidizedMortgageLabelText';
export const SUBSIDIZED_MORTGAGE_LABEL_TEXT_IN_MIXED_LISTING_KEY =
  'frontend-serp.subsidizedMortgageLabelTextInMixedListing';
export const SUBSIDIZED_MORTGAGE_EXCLUDED_REGIONS_KEY = 'frontend-serp.subsidizedMortgageExcludedRegions';
export const SUBSIDIZED_MORTGAGE_OPTION_VALUE = 'subsidizedMortgage';
